module.exports = __webpack_public_path__ + "img/2.a15a1702.jpg";